import React, { useState } from 'react';
import axios from 'axios';
import './CSS/add_app.css';

const AddApp = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [file, setFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !description.trim() || !file) {
      setResponseMessage("All fields are required.");
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('file', file);

    setIsUploading(true);
    setResponseMessage('');
    setUploadProgress(0);

    try {
      const res = await axios.post('https://weynibirhan.com.et/add_app.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        },
      });

      if (res.status === 200 && (res.data?.success || res.data?.message)) {
        setResponseMessage(res.data?.message || 'Upload successful!');
        
        // Reset form after a short delay (optional UX tweak)
        setTimeout(() => {
          setName('');
          setDescription('');
          setFile(null);
          setSelectedFileName('');
          setUploadProgress(0);
          const fileInput = document.querySelector('input[type="file"]');
          if (fileInput) fileInput.value = null;
        }, 500);
      } else {
        setResponseMessage(res.data?.message || 'Upload failed. Please try again.');
      }
    } catch (err) {
      console.error("Upload error:", err.response || err.message);
      setResponseMessage('Error uploading app.');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="add-app-container">
      <h2>Add App</h2>
      <form onSubmit={handleSubmit} className="add-app-form">
        <input
          type="text"
          placeholder="App Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <textarea
          placeholder="App Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        />
        <input
          type="file"
          accept=".apk,.zip"
          onChange={(e) => {
            setFile(e.target.files[0]);
            setSelectedFileName(e.target.files[0]?.name || '');
          }}
          required
        />
        {selectedFileName && <p className="file-status">Attached: {selectedFileName}</p>}

        <button type="submit" disabled={isUploading}>
          {isUploading ? 'Uploading...' : 'Upload App'}
        </button>
      </form>

      {isUploading && <p className="uploading-status">Uploading: {uploadProgress}%</p>}
      {responseMessage && <p className="response-message">{responseMessage}</p>}
    </div>
  );
};

export default AddApp;
